/**
 * Pragmatic auth event logging — frontend only, no PII.
 *
 * Logs a structured code to the console (dev) and can be extended to forward
 * to an analytics endpoint when needed. Never include emails, tokens, or IDs
 * in the code or message — use the optional details object for dev context only,
 * and guard it with NODE_ENV === 'development'.
 *
 * Defined codes:
 *   oauth_start                – user clicked Continue with Google
 *   oauth_callback_ok          – /auth/callback: session received + routing
 *   oauth_callback_no_session  – /auth/callback: no session after retries
 *   oauth_callback_player_error– /auth/callback: player lookup DB error
 *   profile_complete_ok        – /auth/complete-profile: insert succeeded
 *   profile_insert_23505       – /auth/complete-profile: unique violation
 *   profile_complete_error     – /auth/complete-profile: unexpected error
 *   hydrate_signout            – init/listener: signed out due to DB error
 */

const logAuthEvent = (code, devDetails = null) => {
  if (process.env.NODE_ENV === 'development') {
    console.log(`[AUTH_EVENT] ${code}`, devDetails ?? '');
  }
  // Future: forward to analytics with no PII
  // analytics.track('auth_event', { code });
};

export default logAuthEvent;
